// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { AppState } from '@iv/store/app.reducer';
import { AppStore } from '@iv/store/app.store';
import * as TabsActions from '@iv/store/tabs/tabs.actions';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';
import * as Redux from 'redux';
import { CommonService } from '../../../core/services/common.service';
import {
  futHvModel,
  futIvxModel,
  hvModel,
  hvModelAlt,
  ivxModel,
  ivxModelAlt
} from 'app/workspace/summary-line-table/model/summary-line-table';
import { ColorThemeService } from 'app/common/services/color-theme.service';
import { ThemeColor } from 'app/common/enums/theme-color.enum';
import {
  FormControl,
  FormGroup
} from '@angular/forms';
import { Destroyer } from 'app/common/utils';
import {
  pairwise,
  takeUntil
} from 'rxjs/operators';
import { locale } from './ivx30-chart.locale';
import { getPermissions } from '@iv/store/permissions/permissions.reducer';
import { PermissionTypes } from '@iv/store/permissions/permissions.models';
import { TabTypeEnum } from '@iv/model/tabs.model';
import {PaymentWindowService} from '../../../payment-window.service';
import {UDFCompatibleDatafeed} from '@iv/assets/datafeeds/udf/lib/udf-compatible-datafeed';

@Component({
  selector: 'iv-live-x30-chart',
  templateUrl: './ivx30-chart.component.html',
  styleUrls: ['./ivx30-chart.component.scss']
})
export class IVX30ChartComponent extends Destroyer implements OnInit, OnChanges, OnDestroy {

  constructor(
    private commonService: CommonService,
    @Inject(AppStore) private store: Redux.Store<AppState>,
    private colorThemeService: ColorThemeService,
    protected readonly paymentWindowService: PaymentWindowService
  ) {
    super();
    this.unsubscribeStore = store.subscribe(() => this.updateState());
    this.colorThemeService.$colorTheme
      .pipe(takeUntil(this.destroy$))
      .subscribe((colorTheme: string) => {
        this._createChart();
        this.colorTheme = colorTheme;
      });
    this.updateState();
  }

  @Input()
  isShowIvx=true;

  @Input()
  isShowHv=true;

  @Input()
  isRestoreDefaults=true;

  @Input()
  isShowPrice=true;

  @Input()
  isShowChartTypes=true;

  @Input()
  set symbol(symbol: any) {
    this._symbol = symbol || this._symbol;
  }

  @Input()
  set interval(interval) {
    this._interval = interval || this._interval;
  }

  @Input()
  set datafeedUrl(datafeedUrl: string) {
    this._datafeedUrl = datafeedUrl || this._datafeedUrl;
  }

  @Input()
  set libraryPath(libraryPath) {
    this._libraryPath = libraryPath || this._libraryPath;
  }

  @Input()
  set fullscreen(fullscreen) {
    this._fullscreen = fullscreen || this._fullscreen;
  }

  @Input()
  set autosize(autosize) {
    this._autosize = autosize || this._autosize;
  }

  @Input()
  set containerId(containerId) {
    this._containerId = containerId || this._containerId;
  }

  @Input()
  set marketClose(value: boolean) {
    this._marketClose = value;
  }

  @Input()
  set hideCharts(value: boolean) {
    this._hidden = value;
    if (value === false) {
      this._createChart();
    }
  }

  @Input()
  public hv: string;

  @Input()
  public ivx: string;

  @Input()
  public noOptions;

  @Output()
  ivxChange = new EventEmitter<any>();
  @Output()
  hvChange = new EventEmitter<any>();

  @ViewChild('chartFilters')
  private chartFilters: HTMLElement;
  @ViewChild('ivx30Container', {static: false})
  private container !: ElementRef;

  get symbol(): any {
    return this._symbol;
  }

  get marketClose(): boolean {
    return this._marketClose;
  }

  get chartType(): number {
    return this._chartType;
  }

  set chartType(value: number) {
    if (this._chartType !== value) {
      this._chartType = value;
      const container = <HTMLElement>document.getElementsByClassName('app-tv-chart-container')[0];
      const frame = (container ? <HTMLElement>container.childNodes[0] : null);
      if (this._widget
        && frame
        && frame.tagName === 'IFRAME'
      ) {
        this._widget.applyOverrides({
          'mainSeriesProperties.style': value
        });
      }
    }
  }

  public ivxHvForm = new FormGroup({
    ivx: new FormControl(),
    hv: new FormControl()
  });
  public colorTheme;
  public themeColorEnum = ThemeColor;
  public showChartTypes = true;
  public showIXV = true;
  public showSTOCK = true;
  public showHV = true;
  @Input()
  public resolution = null;
  public fsMode = false;
  public IVX: string[] = ivxModelAlt;
  public HV: string[] = hvModel;
  public ivxLabel = '30';
  public hvLabel = '20';
  public showIvxTip = true;
  public showHvTip = true;
  public widescreen: boolean;
  public hvDisabled: boolean;
  public ivolLinkText: string;
  public activeItem = false;
  public fullScreen: Object = null;
  public locale = locale;
  public currentTab;

  private unsubscribeStore;
  private _widget = null;
  private _STOCKId = null;
  private _HVId = null;
  private _timeframe = '1D';
  private _timezone = 'America/New_York';
  private _chartsStorageUrl = '/user-settings/tradingview';
  // 'https://saveload.tradingview.com';//`/user-settings/charts`; //
  private _chartsStorageApiVersion = '1.1';
  private _userId = sessionStorage.getItem('userId');
  private _hidden = true;
  private _symbol: any = 'MSFT';
  private _clientId = '1'; //this._symbol;
  private _interval = '1';
  private _datafeedUrl: string; // 'https://demo_feed.tradingview.com';// - ссылка на демо
  private _libraryPath = '/iv-live/assets/charting_library/';
  private _fullscreen = false;
  private _autosize = true;
  private _containerId = 'tv_chart_container';
  private _chartType = 2;
  private _marketClose = false;
  private futExpDate: string;

  private ivxDropdown = null;
  private hvDropdown = null;
  private fsButton = null;
  private upButton = null;

  private static _showDayData(me) {
    if (!me.marketClose) {
      IVX30ChartComponent._showTodayData(me);
    } else {
      me._showPrevDayData(me);
    }
  }

  private static _showTodayData(me) {
    const now = new Date();
    const start = new Date();
    start.setHours(9);
    start.setMinutes(25);
    me._setVisibleRange(start, now);
  }

  private static _showPrevMonthData(me) {
    const now = new Date();
    const start = new Date();
    start.setMonth((now.getMonth() === 0) ? 11 : now.getMonth() - 1);
    start.setFullYear((now.getMonth() === 0) ? (now.getFullYear() - 1) : now.getFullYear());
    me._setVisibleRange(start, now);
  }

  // ----------------------- ХУКИ -----------------------
  public ngOnInit(): void {

    this.paymentWindowService.showPaymentWindow();

    this.ivxHvForm.get('ivx').setValue(this.ivx);
    this.ivxHvForm.get('hv').setValue(this.hv);

    const table = document.querySelector('.instrument-details_chart__IVX30') as HTMLElement;

    if (this.noOptions || this._symbol.regionId !== 1) {
      this._interval = '1D';
      this._timeframe = '1M';
    }

    if (!this.noOptions && this._symbol.regionId === 1 && this.isMonday()) {
      this._timeframe = '3D';
    }

    if (this.isHoliday()) {
      const day = new Date().getDay();
      const firstTimeFrame = ((day === 0) ? '1M' : '2d');
      this._timeframe =  firstTimeFrame
      this.resolution = '1';
    }

    this._createChart();

    if (this._symbol.regionId === 1) this.IVX = ivxModel;
    if (this._symbol.regionId === 3) {
      this.HV = hvModelAlt;
      this.ivxHvForm.get('hv').setValue('30');
    }

    if (this.currentTab.type === TabTypeEnum.FUTURES_OPTION_CHAIN) {
      this.HV = futHvModel;
      this.IVX = futIvxModel;
      this.hvLabel = '30';
      this._interval = '1D';
      this._timeframe = '1M';
      this.resolution = '1D';
    }

    this._createChart();

    const frame = <HTMLElement>document.getElementsByClassName('app-tv-chart-container')[0].childNodes[0];

    this.commonService.goal
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (res === true && frame !== undefined && frame.tagName === 'IFRAME') {
          try {
            this.destroyWidget();
          } catch (error) {

          }
        }
      });

    this.onResize(table);
    this.ivxHvFormSubscription();
    this._fillLocalStorage();

    setTimeout(() => sessionStorage.setItem('sendUserMetrics', 'false'), 12 * 1000);

  }

  public ngOnChanges(changes: SimpleChanges): void {

    const changesKey = Object.keys(changes).filter((key: string) => key === 'hv' || key === 'ivx')[0];
    const changesCurrentValue = changes[changesKey]?.currentValue;

    if (changesCurrentValue !== changes[changesKey]?.previousValue && changesCurrentValue) {
      this.ivxHvForm.get(changesKey).setValue(changesCurrentValue);
      this._reRenderChart(changesKey);
    }

    if (this._widget) {
      this.createHeaderButtons();
    }
  }

  public ngOnDestroy(): void {
    if (typeof this.unsubscribeStore === 'function') {
      this.unsubscribeStore();
    }

    super.ngOnDestroy();
  }

  // ----------------------------------------------------
  private createHeaderButtons() {
    if (this.hvDropdown) this.hvDropdown.remove();
    if (this.ivxDropdown) this.ivxDropdown.remove();
    if (this.fsButton) this.fsButton.remove();
    if (this.upButton) this.upButton.remove();

    const iframeWindow = document.querySelector('#tv_chart_container > iframe').contentWindow;
    if (typeof this._widget.createDropdown === 'function') {
      iframeWindow.tvFsButtonHandler = () => this.setFsMode();
      this._widget.createDropdown({title: '', items: [], icon: `<svg onclick="tvFsButtonHandler()" id="fs-button" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.00002 3.99998H4.00004L4 9M20 8.99999V4L15 3.99997M15 20H20L20 15M4 15L4 20L9.00002 20" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`}).then(button => {
        if (this.fsButton) this.fsButton.remove();
        this.fsButton = button;
      });

      if (this.isRestoreDefaults) {
        iframeWindow.tvUpButtonHandler = () => this.restoreDefaultChart();
        this._widget.createDropdown({title: '', items: [], icon: `<svg onclick="tvUpButtonHandler()" id="up-button" width="18px" height="18px" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 456.556 456.556" style="enable-background:new 0 0 456.556 456.556;" xml:space="preserve">
          <g>
            <path d="M24.381,273.57c-6.504,0-12.211-4.728-13.253-11.351C-3.937,166.131,47.167,70.288,135.415,29.136
              c94.633-44.138,205.059-14.799,266.527,64.476V13.428C401.942,6.015,407.957,0,415.37,0c7.413,0,13.428,6.015,13.428,13.428
              v127.763c0,4.105-1.881,7.987-5.098,10.533c-3.224,2.553-7.413,3.497-11.428,2.532l-110.313-26.15
              c-7.211-1.706-11.68-8.945-9.966-16.156c1.707-7.218,8.966-11.708,16.156-9.973l80.436,19.009
              C336.62,43.264,234.063,12.764,146.759,53.475C69.303,89.598,24.437,173.726,37.663,258.065c1.147,7.323-3.861,14.197-11.19,15.344
              C25.773,273.521,25.067,273.57,24.381,273.57z"/>
            <path d="M41.299,456.556c-7.413,0-13.428-6.015-13.428-13.428V315.533c0-0.042,0-0.084,0-0.126v-0.042
              c0-4.105,1.881-7.987,5.098-10.533c3.231-2.553,7.434-3.476,11.428-2.532l110.313,26.15c7.211,1.706,11.673,8.938,9.966,16.156
              c-1.706,7.218-8.938,11.687-16.149,9.98l-0.021-0.007l-80.541-19.016c51.964,77.743,154.521,108.236,241.832,67.525
              c77.435-36.116,122.301-120.224,109.103-204.534c-1.147-7.33,3.861-14.197,11.19-15.344c7.406-1.203,14.197,3.868,15.344,11.19
              c15.037,96.067-36.074,191.889-124.294,233.027c-94.577,44.117-204.933,14.834-266.415-64.329v80.03
              C54.728,450.541,48.713,456.556,41.299,456.556z"/>
          </g>
        </svg>`}).then(button => {
          if (this.upButton) this.upButton.remove();
          this.upButton = button;
        });
      }
      if (this.IVX && !this.noOptions && this.isShowIvx && !this.ivxHvForm.get('ivx').disabled) {
        this._widget.createDropdown({
          title: 'IVX' + this.ivxHvForm.get('ivx').value,
          items: this.IVX.map((item, index) => ({title: 'IVX' + item, onSelect: () => this.ivxChange.emit(item)}))
        }).then(dropdown => {
          if (this.ivxDropdown) this.ivxDropdown.remove();
          this.ivxDropdown = dropdown;
        });
      }
      if (this.HV && this.isShowHv && !this.ivxHvForm.get('hv').disabled && !this.hvDisabled) {
        this._widget.createDropdown({
          title: 'HV' + this.ivxHvForm.get('hv').value,
          items: this.HV.map((item, index) => ({title: 'HV' + item, onSelect: () => this.hvChange.emit(item)}))
        }).then(dropdown => {
          if (this.hvDropdown) this.hvDropdown.remove();
          this.hvDropdown = dropdown;
        });
      }
    }
  }

  public setFsMode() {
    return this.fsMode = !this.fsMode;
  }

  public onResize(event: HTMLElement): void {
    this.widescreen = (event.offsetWidth > 1118);
    if (event.offsetWidth <= 861) {
      this.ivolLinkText = '';
    } else if (event.offsetWidth > 861 && event.offsetWidth < 1100) {
      this.ivolLinkText = 'IVolatility.com';
    } else {
      this.ivolLinkText = 'Data and Analytics by IVolatility.com';
    }
  }

  setChartType(chartType) {
    this.store.dispatch(TabsActions.updateTabData({
      name: 'chartType',
      value: chartType
    }));
  }

  isMonday() {
    const day = new Date().getDay();
    return day === 1;
  }

  isHoliday(): boolean {
    const day = new Date().getDay();
    return day === 6 || day === 0;
  }

  public togglePrice(): void {
    this.showSTOCK = !this.showSTOCK;
    if (this._widget && this._widget.chart() && this._STOCKId) {
      this._widget.chart().getStudyById(this._STOCKId).setVisible(this.showSTOCK);
    }
  }

  ivClick(ivx, index) {
    const ivxItems = document.querySelectorAll('.ivx-item');
    ivxItems.forEach(ivxItem => {
      ivxItem.classList.remove('active');
    });
    ivxItems[index].classList.add('active');
    this.ivxLabel = ivx;
    this.ivxChange.emit(ivx);
  }

  hvClick(hv, index) {
    const hvItems = document.querySelectorAll('.hv-item');
    hvItems.forEach(hvItem => {
      hvItem.classList.remove('active');
    });
    hvItems[index].classList.add('active');
    this.hvLabel = hv;
    this.hvChange.emit(hv);
  }

  restoreDefaultChart() {
    this.showIXV = true;
    this.showSTOCK = true;
    this.showHV = true;
    if (this._widget) {
      this._widget.remove();
      this._createChart();
    }
  }

  private _createChart() {

    this.colorTheme = localStorage.getItem('theme');
    const day = new Date().getDay();
    const firstTimeFrame = ((day === 1) ? '3d' : '2d');
    const oneMinuteResolution = [
      {text: firstTimeFrame, resolution: '1', description: '1 Day', title: '1D'},
      {text: '24', resolution: '1', description: '24H', title: '24H'}
    ];

    const oneDayResolution = [
      {text: '1m', resolution: '1D', description: '1 Month', title: '1Mo'},
      {text: '3m', resolution: '1D', description: '2 Months', title: '3Mo'},
      {text: '6m', resolution: '1D', description: '6 Months', title: '6Mo'},
      {text: '1y', resolution: '1D', description: '1 Year', title: '1Y'}
    ];
    const oneWeekResolution = [
      {text: '5y', resolution: '1W', description: '5 Years', title: '5Y'}
    ];
    const getTimeFrames = () => {
      const bigResolution = [...oneDayResolution, ...oneWeekResolution];
      if (this.currentTab.type === TabTypeEnum.OPTION_CHAIN) {
        if (this.symbol.regionId !== 1) {
          return bigResolution;
        }
        return [
          ...oneMinuteResolution,
          ...oneDayResolution,
          ...oneWeekResolution
        ];
      } else {
        return bigResolution;
      }
    };

    const widgetOptions = {
      symbol: this._getSymbol(this.noOptions ? 'HV' : 'IVX'),//.split(':')[0],
      datafeed: new UDFCompatibleDatafeed(this._datafeedUrl),
      interval: this._interval,
      container: this._containerId,
      library_path: this._libraryPath,
      locale: 'en',
      timezone: this._timezone,
      debug: true,
      disabled_features: [
        'header_undo_redo',
        // 'header_settings',
        'header_symbol_search',
        'header_chart_type',
        'header_compare',
        'header_fullscreen_button',
        'symbol_search_hot_key',
        'use_localstorage_for_settings',
        'go_to_date',
        'context_menus',
        'legend_context_menu',
        'symbol_info',
        'control_bar',
        'compare_symbol',
        'border_around_the_chart',
        'remove_library_container_border',
        'legend_context_menu',
        'header_chart_type',
        // 'widget_logo'
      ],
      enabled_features: [
        'study_symbol_ticker_description',
        'hide_left_toolbar_by_default',
        'study_templates',
        'header_saveload',
        'dont_show_boolean_study_arguments',
        'hide_last_na_study_output',
        'keep_left_toolbar_visible_on_small_screens'
      ],
      charts_storage_url: this._chartsStorageUrl,
      charts_storage_api_version: this._chartsStorageApiVersion,
      client_id: this._clientId,
      user_id: this._userId,
      fullscreen: this._fullscreen,
      autosize: this._autosize,
      timeframe: this._timeframe,
      time_frames: getTimeFrames(),
      overrides: {
        'scalesProperties.backgroundColor': this.colorTheme === this.themeColorEnum.DARK ? '#131722' : '#fff',
        'mainSeriesProperties.priceAxisProperties.percentage': false,
        'mainSeriesProperties.priceAxisProperties.percentageDisabled': false,
        'mainSeriesProperties.lineStyle.color': (this.noOptions ? '#FF7C00' : '#00AD80'),
        'mainSeriesProperties.lineStyle.linewidth': 2,
        'mainSeriesProperties.style': 2
      },
      customFormatters: {
        timeFormatter: {
          format: function (date) {
            return date.getUTCHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
          },
          formatLocal: function (date) {
            return date.getUTCHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
          }
        },
        dateFormatter: {
          format: function (date) {
            return date.getUTCFullYear() + '/' + (date.getUTCMonth() + 1) + '/' + date.getUTCDate();
          },
          formatLocal: function (date) {
            return date.getUTCFullYear() + '/' + (date.getUTCMonth() + 1) + '/' + date.getUTCDate();
          }
        }
      },
      theme: this.colorTheme,
      toolbar_bg: this.colorTheme === ThemeColor.DARK ? '#131722' : '#fff'
    };

    this._widget = new TradingView.widget(widgetOptions);
    this._widget.allowFullscreen = false;
    // var templ = JSON.parse('TEMPLATE_FROM_DB'); widget.chart().applyStudyTemplate(templ);

    this._widget.onChartReady(() => {
      const me = this;
      if (this.symbol.regionId === 4 || this.currentTab.type === TabTypeEnum.FUTURES_OPTION_CHAIN) {
        this.chartType = 2;
      }
      this._widget.applyOverrides({
        'mainSeriesProperties.style': (this.noOptions ? 2 : this.chartType)
      });
      if (!this.noOptions) {
        this._createPrice(() => {
          this._createHV();
        });

        this._widget.chart()
          .onIntervalChanged()
          .subscribe(null, function (interval, obj) {
            if (obj.timeframe && obj.timeframe.indexOf('m') > -1) {
              me._widget.applyOverrides({
                'mainSeriesProperties.style': 2
              });
              me.showChartTypes = false;
            } else {
              me.showChartTypes = true;
            }
          });

        this._widget.chart()
          .onVisibleRangeChanged()
          .subscribe(null, function () {
            const frame = <HTMLIFrameElement>document.getElementsByClassName('app-tv-chart-container')[0].childNodes[0];
            const a = frame.contentWindow.document.getElementsByClassName('date-range-preset-btn apply-common-tooltip active')[0];
            if (a && ((a.innerHTML === '24H'))) {
              me._show24HoursData(me);
            }
            if (a && (a.innerHTML === '1D')) {
              IVX30ChartComponent._showDayData(me);
            }
            me.resolution = me._widget.chart().resolution();
            me._createHV();
          });

        if (this._symbol.regionId === 1) {
          if (!this._marketClose) {
            IVX30ChartComponent._showTodayData(me);
          } else {
            me._show24HoursData(me);
          }

        } else {
          IVX30ChartComponent._showPrevMonthData(me);
        }

      } else {
        this._createPrice(() => {
          IVX30ChartComponent._showPrevMonthData(this);
        });
      }

      if (this.currentTab.type === TabTypeEnum.FUTURES_OPTION_CHAIN) {
        IVX30ChartComponent._showPrevMonthData(this);
      }
    });
  }

  private destroyWidget(): void {
    this._widget.remove();
    this._widget = null;
  }

  private ivxHvFormSubscription(): void {
    this.ivxHvForm
      .valueChanges
      .pipe(
        pairwise(),
        takeUntil(this.destroy$)
      )
      .subscribe(([prev, curr]) => {
        if (prev.hv !== curr.hv) {
          this.hvChange.emit(curr.hv);
          this.hvLabel = curr.hv;
          return;
        }

        if (prev.ivx !== curr.ivx) {
          this.ivxChange.emit(curr.ivx);
          this.ivxLabel = curr.hv;
        }
      });
  }

  private updateState(): void {
    this.currentTab = getCurrentTab(this.store.getState());
    if (this.currentTab && (this.currentTab.data.chartType || this.currentTab.data.chartType === 0)) {
      this.chartType = this.currentTab.data.chartType;
    } else {
       this.currentTab = {type: 'instrument'}
    }
  }

  private _show24HoursData(me) {
    const now = new Date();
    const start = new Date();
    start.setDate(now.getDate() - 1);
    start.setDate(now.getDate() - (this.isMonday() ? 3 : 1));
    me._setVisibleRange(start, now);
  }

  private _showPrevDayData(me) {
    const now = new Date();
    const start = new Date();
    start.setDate(now.getDate() - (this.isMonday() ? 3 : 1));
    start.setHours(9);
    start.setMinutes(29);
    me._setVisibleRange(start, now);
  }

  private _setVisibleRange(from, to) {
    try {
      if (this._widget && this._widget.chart()) {
        const a = {
          from: parseInt((from.getTime() / 1000).toString(), 10),
          to: parseInt((to.getTime() / 1000).toString(), 10)
        };
        this._widget.chart().setVisibleRange(a, { percentRightMargin: 20 });
      }
    } catch (e) {
      console.error('chart is undefined');
    }
  }

  private _reRenderChart(type) {
    const frame = <HTMLElement>document.getElementsByClassName('app-tv-chart-container')[0].childNodes[0];
    if (frame !== undefined && frame.tagName === 'IFRAME') {
      try {
        if (!this.noOptions && type === 'ivx') {
          this._widget.setSymbol(this._getSymbol('IVX'), this._widget.chart().resolution(), () => {
          });
        }
        if (!this.noOptions && type === 'hv' && this._HVId) {
          this._removeHV();
          this._createHV();
        }
        if (this.noOptions && type === 'hv') {
          this._widget.setSymbol(this._getSymbol('HV'), this._widget.chart().resolution(), () => {
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  private _removeHV() {
    this.hvDisabled = true;

    if (this._widget && this._widget.chart() && this._HVId) {
      this._widget.chart().removeEntity(this._HVId);
      this._HVId = null;
    }

    if (!this.widescreen && this.ivxHvForm.get('hv').enabled) {
      this.ivxHvForm.get('hv').disable();
    }

    this.createHeaderButtons();
  }

  private _createPrice(callback?) {
    this._createStudy(this.currentTab.type === TabTypeEnum.FUTURES_OPTION_CHAIN ? 'PRICE' : 'STOCK', '#5f5bff', 'new-left', callback);
  }

  private _createHV() {
    if (this.resolution && this.resolution !== '1' && this.resolution !== '5' && !this._HVId) {
      this._createStudy('HV', '#FF7C00', 'new-right');

      this.hvDisabled = false;

      if (!this.widescreen && this.ivxHvForm.get('hv').disabled) {
        this.ivxHvForm.get('hv').enable();
      }

      this.createHeaderButtons();
    } else if (this.resolution === '1' || this.resolution === '5') {
      this._removeHV();
    }
  }

  private _createStudy(type: string, color: string, priceScalePosition, callback?) {
    if (this[`_${type}Id`]) this._widget.chart().removeEntity(this[`_${type}Id`]);

    this._widget.chart().createStudy(
      'Compare',
      false,
      false,
      [['close'], this._getSymbol(type)],
      {
        'plot.color': color,
        'plot.linewidth': 2
      },
      {
        priceScale: priceScalePosition
      }
    ).then((entityId) => {
      if (this[`_${type}Id`]) this._widget.chart().removeEntity(this[`_${type}Id`]);

      this[`_${type}Id`] = entityId;
      this._widget.chart().getPanes()[0].getMainSourcePriceScale().setMode(0);
      this._widget.chart().getStudyById(this[`_${type}Id`]).setVisible(this[`show${type}`]);
      if (callback) {
        callback();
      }
    });
  }

  private _getSymbol(type) {
    const permissions = getPermissions(this.store.getState());
    let mode: string;

    if (this.currentTab.type === TabTypeEnum.OPTION_CHAIN) {
      mode = permissions.find((permission: string) => {
        switch (permission) {
          case PermissionTypes.DELAYED_STOCKS:
          case PermissionTypes.RT_STOCKS:
            return permission;
        }
      })?.split('_')[0].toLowerCase();
    } else if (this.currentTab.type === TabTypeEnum.FUTURES_OPTION_CHAIN) {
      mode = 'eod';
    }

    sessionStorage.setItem('tradingViewMode', mode);

    return [
      this._symbol.symbol,
      this._symbol[this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? 'exchange' : 'code'],
      this._symbol[this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? 'stockId' : 'underlyingId'],
      type,
      sessionStorage.getItem('userId'),
      mode,
      (type === 'HV' ? +this.ivxHvForm.get('hv').value : +this.ivxHvForm.get('ivx').value),
      String(!this.noOptions)
    ].join(':');
  }

  private _fillLocalStorage() {
    const id = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? 'stockId' : 'underlyingId';
    const exchange = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? 'exchange' : 'code';

    sessionStorage.setItem('name', this._symbol.symbol);
    sessionStorage.setItem(id, this._symbol[id]);
    sessionStorage.setItem(exchange, this._symbol[exchange]);
    sessionStorage.setItem('ivxTerm', (this.noOptions ? this.ivxHvForm.get('hv').value : this.ivxHvForm.get('ivx').value));
    sessionStorage.setItem('iv-live-type', (this.noOptions ? 'HV' : 'IVX'));
    sessionStorage.setItem('hasOptions', String(!this.noOptions));
    sessionStorage.setItem('sendUserMetrics', 'true');

    if (this.currentTab.type === TabTypeEnum.FUTURES_OPTION_CHAIN) {
      sessionStorage.setItem('underlyingId', this.currentTab.data?.future?.underlyingId);
    }
  }
}
